
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/service",
      function () {
        return require("private-next-pages/cases/service/index.tsx");
      }
    ]);
  